const CONSTANTS = {
    //Typical Device info
    MIN_SCREEN_WIDTH: 320,
 
    //Design related constants
    TEXT_INPUT_LABEL_BACKGROUND: '#ffffff',
    APP_BACKGROUND_COLOR: '#E6E6E6',
    BORDER_COLOR: '#E6E6E6',
    PRIMARY_COLOR_BLUE: '#0092C8',
    PRIMARY_COLOR_MATCH_WHITE: '#ffffff', //often on text for buttons using the PRIMARY_COLOR_BLUE
    SECONDARY_COLOR: '#dc004e',
    LINK_COLOR: 'rgb(0, 147, 200)'
    
    //Other constants can be added here as needed
}
 
export default CONSTANTS;